"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
exports.whitelistByPageFlag = {
    0: ["setting"],
    1: ["setting", "mainStep", "ProjectInfo", "ProjectInitiationData"],
    2: [
        "setting",
        "mainStep",
        "ProjectInfo",
        "ProjectInitiationData",
        "saveCSVDataS21",
        "columnSelectionS22",
        "nullValueColumns",
        "featureSelections",
        "handlingMissingValues",
        "outlierVisualizations",
        "interpolationData",
        "lagVariables",
        "binary_thresholding",
        "feature_mapping_data"
    ],
    3: [
        "setting",
        "mainStep",
        "ProjectInfo",
        "samplingMethod",
        "trainTestRatio",
        "saveCSVDataS21",
        "ProjectInitiationData",
        "columnSelectionS22",
        "nullValueColumns",
        "featureSelections",
        "columnSelectionS32",
        "handlingMissingValues",
        "outlierVisualizations",
        "interpolationData",
        "lagVariables"
    ],
    4: [
        "setting",
        "mainStep",
        "ProjectInfo",
        "samplingMethod",
        "trainTestRatio",
        "saveCSVDataS21",
        "ProjectInitiationData",
        "columnSelectionS22",
        "nullValueColumns",
        "featureSelections",
        "columnSelectionS32",
        "handlingMissingValues",
        "outlierVisualizations",
        "interpolationData",
        "lagVariables",
        "model_selection",
        "graph_path"
    ],
    5: [
        "setting",
        "mainStep",
        "ProjectInfo",
        "samplingMethod",
        "trainTestRatio",
        "finalData",
        "saveCSVDataS21",
        "ProjectInitiationData",
        "columnSelectionS22",
        "nullValueColumns",
        "featureSelections",
        "columnSelectionS32",
        "handlingMissingValues",
        "outlierVisualizations",
        "interpolationData",
        "lagVariables",
        "graph_path"
    ]
};
exports.DynamicWhitelist = () => {
    const savedFlag = localStorage.getItem("pageFlag");
    const pageFlag = savedFlag ? Number(savedFlag) : 0;
    const allKeys = Array.from(new Set(Object.values(exports.whitelistByPageFlag).flat())); // Get all unique keys from all pages
    const whitelist = exports.whitelistByPageFlag[pageFlag] || [];
    const resetKeys = allKeys.filter(key => !whitelist.includes(key));
    return { whitelist, resetKeys };
};
//# sourceMappingURL=DynamicWhitelist.js.map